import { C } from "@angular/core/src/render3";

export class OrderRequestModel {
    sellType: string;
    consumerId: string;
    orderItems: OrderItemModel[] = new Array<OrderItemModel>();
    orderLrsItemList: LrsDeclaration[] = new Array<LrsDeclaration>();
    orderDocumentMappingRequest: any = null;
    payerType: string = "SELF";
    beneficiaryDetails = new BeneficiaryCreateRequest();
    ddDetailsRequest = new ddDetailsRequest();
    kycMode: string;
    partnerId: string;
    quotationSnapshotId: string;
    passportNumber: string;
    pan: string;
    departureDate: string;
    address: string;
    visitingCountry: string;
    numberOfDays: number;
    passportIssueDate: string;
    passportExpiryDate: string;
    passportIssuePlace: string;
    wsflReferenceBranchId: string;
    refferedPartnerId: string;
    orderPunchType: string;
    dealId: String;
    dealProvider: String;
    orderType: any;
    agentCommission: number;
    wsfxCommission: number;
    ad1BankName: string;
    ad1BankType: string;
    countryCode: string;
    hsbcDebitAdviceReceived: string;
    studentFirstName: string;
    studentLastName: string;
    beneficiaryName: string;
    universityName: string;
    beneficiaryBankName: string;
    beneficiaryAccountNumber: string;
    beneficiaryBankAddress: string;
    swiftCode: string;
    iban: string;
    consumerLeadId: string;
    userId: string;
    branchId: string;
}

export class LrsDeclaration {
    pan: string;
    lrsDeclarationAmount: number;
    instituteName: string;
    transactionDate: Date;
}
export class BeneficiaryModel {
    payerType: string;
    payer = new Payer();
    beneficiaryCreateRequest: BeneficiaryCreateRequest =
    new BeneficiaryCreateRequest();
    ddDetailsRequest: ddDetailsRequest = new ddDetailsRequest();
    paxCreateRequest: PaxCreateRequest = new PaxCreateRequest();
}

export class Payer {
    orderId: any;
    payerPan: string;
    payerType: string;
    remittanceType: any;
    payerName: any;
    consumerId: string;
    createdAt: any;
    updatedAt: any;
    paxId: string;
}

export class BeneficiaryCreateRequest {
    consumerId: string;
    address: string;
    bankAccountNumber: string;
    bankAddress: string;
    bankName: string;
    countryCode: string;
    createdAt: string;
    id: string;
    name: string;
    sortCode: string;
    swiftCode: string;
    updatedAt: string;
    additionalDetails: string;
    studentId: string;
    flyWireReferenceNumber: string;
}
export class ddDetailsRequest {
    ddInFavourOf: string;
    ddReferenceNumber: string;
}
export class RemitTransactionRequest {
    CorporateId: string;
    CorporateReferenceNo: string;
    UserId: string;
    orderId: string;
}
export class RemitOrderRequest {
    CorporateId: string;
    UserId: string;
    customerRefeNumber: string;
    downloadType: string;
    orderId: string;
}
export class PaxCreateRequest {
    consumerId: string;
    name: string;
    mobile: string;
    dob: string;
    email: string;
    nationality: string;
    ddInFavourOf: string;
    ddReferenceNumber: string;
    residentStatus: string;
    occupation: string;
    address: string;
    id: string;
    type: string;
    countryCode: string;
    passportNumber: string;
    surname: string;
    givenName: string;
    gender: string;
    dateOfBirth: string;
    placeOfBirth: string;
    photo: string;
    signature: string;
    otherId: string;
    passportIssueDate: string;
    passportExpiryDate: string;
    passportIssuePlace: string;
    ticketNumber: string;
    departureDate: string;
    arrivalDate: string;
    visitingCountry: string;
    numberOfDays: number;
    pan: string;
    cardDeliveryAddress: string;
    cardDeliveryDate: string;
    cardDeliveryTime: string;
    deliveryAddressType: string;
    cardDeliveryBranch: any;
}
export class PolicyRequest {
    insuranceOrderId: string;
    orderformdetailsId: string;
}
export class OrderItemModel {
    currencyAmount: number;
    currencyCode: string;
    product: string;
    purpose: string;
    countryCode: string;
    bidRate: number;
    wsfxCommissionPerUnit: number;
    partnerCommissionPerUnit: number;
    //PARAMS REQUIRED BY UI
    cardRate: number;
    inrAmount: number;
    totalCommissionPerUnit: number;
    serviceChargesShare: number;
    min: number;
    max: number;
    commission: number;
    discount: number;
    partnerCommissionsInr: number;
    totalCommissionsInr: number; //change the name commission to totalCommissionsInr
    wsfxCommissionsInr: number;
    agentCommission: number;
    wsfxCommission: number;
    subPurpose: string;
}
export class AadharFrontRequestModel {
    id: string;
    fullName: string;
    dateOfBirth: string;
    aadharNumber: string;
    photo: string;
    mobile: string;
    email: string;
}
export class AadharBackRequestModel {
    id: string;
    fathersName: string;
    address: string;
}
export class ChequeRequestModel {
    amount: number;
    issuerBankName: string;
    issuerBankAddress: string;
    issuerBankIfsc: string;
    issuerBankChequeNumber: string;
    issuerBankMicrCode: string;
    issuingCustomerName: string;
    beneficiaryAccountNumber: string;
    dateOnCheque: string;
    orderId: string;
    consumerId: string;
}
export class DDRequestModel {
    amount: number;
    issuerBankName: string;
    issuerBankAddress: string;
    issuerBankIfsc: string;
    issuerBankDdNumber: string;
    issuerBankMicrCode: string;
    issuingCustomerName: string;
    beneficiaryAccountNumber: string;
    dateOnDd: string;
    orderId: string;
    consumerId: string;
}
export class PANRequestModel {
    id: string;
    fullName: string;
    fathersName: string;
    dateOfBirth: string;
    permanentAccountNumber: string;
    signatureBox: string;
    photo: string;
}
export class PassportFrontRequestModel {
    id: string;
    type: string;
    countryCode: string;
    passportNo: string;
    surname: string;
    givenName: string;
    nationality: string;
    gender: string;
    dateOfBirth: string;
    placeOfBirth: string;
    placeOfIssue: string;
    dateOfIssue: string;
    dateOfExpiry: string;
    photo: string;
    signature: string;
}
export class PassportBackRequestModel {
    id: string;
    nameOfFather: string;
    nameOfMother: string;
    nameOfSpouse: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    oldPassportNumber: string;
    fileNumber: string;
}
export class UniversityRequestModel {
    id: string;
    surname: string;
    givenNameOrFirstName: string;
    preferredName: string;
    passportName: string;
    countryOfBirth: string;
    countryOfCitizenship: string;
    dateOfBirth: string;
    admissionNumber: string;
    formIssueReason: string;
    legacyName: string;
    academicClass: string;
    schoolName: string;
    schoolAddress: string;
    schoolOfficialContact: string;
    schoolCodeAndApprovalDate: string;
    educationLevel: string;
    major1: string;
    major2: string;
    normalProgramLength: string;
    programEnglishProficiency: string;
    englishProficiencyNotes: string;
    programStartDate: string;
    programEndDate: string;
    estimatedAverageCostsFor: string;
    tuitionFees: string;
    livingExpenses: string;
    expensesOfDependants: string;
    personalFunds: string;
    scholarship: string;
    fundsFromOtherSource: string;
    onCampusEmployment: string;
    issueDate: string;
    placeOfIssue: string;
}
export class DrivingLicence {
    address: string;
    dateOfBirth: string;
    drivingLicenceNumber: string;
    fathersName: string;
    fullName: string;
    id: string;
    pin: string;
}
export class DrivingLicenceRequest {
    address: string;
    dateOfBirth: string;
    drivingLicenceNumber: string;
    fathersName: string;
    fullName: string;
    id: string;
    pin: string;
}
export class DocumentVoterIdRequest {
    id: string;
    fullName: string;
    fathersName: string;
    sex: string;
    dateOfBirth: string;
    voterIdNumber: string;
    address: string;
}

export class OtherDocumentRequest {
    id: string;
    firstName: string;
    LastName: string;
    dateOfBirth: string;
    address: string;
    documentIdNumber: string;
    createdAt: string;
}

export class OrderStatusUpdateRequest {
    kycStatus: string;
    documentsStatus: string;
    beneficiaryDetailsStatus: string;
    paymentStatus: string;
    swiftStatus: string;
    orderStatus: string;
    complianceStatus: string;
    invoiceStatus: string;
    statusType: string;
    comment: string;
}

export class CountryModel {
    countryCode: string;
    countryName: string;
}

export class RequestMapBeneficiaryModel {
    beneficiaryId: string;
    orderId: string;
}

export class vkycModel {
    statusChangeReason: string;
    vkycStatus: string;
    consumerId: string;
    vkycType: string;
    consumerBeneficiaryId: string;
    statusType: string;
    changeStatus: string;
}
export class esignedDocument {
    consumerId: string;
    refOrderId: string;
}
export class createVirtualRequest {
    vAccountId: string;
    vaccountId: string;
    name: string;
    phone: string;
    email: string;
    remitterAccount: string;
    remitterIfsc: string;
    consumerId: string;
}

export class CredilaOrdersRequest {
    orderId: string;
    caseId: string;
    executedRate: any;
    nostroChargesInInr: any;
    remittingToCountry: string;
    ddNumber: any;
    chargeCode: any;
    hsbcDebitAdviceReceived: any;
    disbursementStatus: any;
    applicationId: any;
    customIbr: any;
}
export class CredilaStudentRequest {
    orderId: string;
    credilaQuoteOrderId: string;
    studentTitle: string;
    studentFirstName: string;
    studentMiddleName: string;
    studentLastName: string;
    studentGender: string;
    studentMobileNumber: string;
    studentEmailId: string;
    studentNationality: string;
    studentResidentStatus: string;
    studentPan: string;
    studentDob: any;
    studentPassportNumber: string;
    studentPassportPlaceOfIssue: string;
    studentPassportIssueDate: any;
    studentPassportExpiryDate: any;
    studentAddressAsPerPassport: string;
    studentCurrentHouseNumber: string;
    studentCurrentStreet: string;
    studentCurrentLocality: string;
    studentCurrentPinCode: string;
    studentCountry: string;
    studentState: string;
    studentCity: string;
    studentOccupation: string;
    studentRelation: string;
    relationName: string;
    studentCourse: string;
    studentCourseDuration: string;
    studentCourseStartDate: string;
    studentId: string;
}

export class CredilaCoApplicantRequest {
    payerRelationWithStudent: string;
    remitterPaymentSource: string;
    financialInstitution: string;
    orderId: string;
    credilaQuoteOrderId: string;
    coApplicantTitle: string;
    coApplicantFirstName: string;
    coApplicantMiddleName: string;
    coApplicantLastName: string;
    coApplicantGender: string;
    coApplicantMobileNumber: string;
    coApplicantEmailId: string;
    coApplicantNationality: string;
    coApplicantResidentStatus: string;
    coApplicantPan: string;
    coApplicantDob: any;
    coApplicantPassportNumber: string;
    coApplicantPassportPlaceOfIssue: string;
    coApplicantPassportIssueDate: any;
    coApplicantPassportExpiryDate: any;
    coApplicantAddressAsPerPassport: string;
    coApplicantRelation: string;
    coApplicantCurrentHouseNumber: string;
    coApplicantCurrentStreet: string;
    coApplicantCurrentLocality: string;
    coApplicantCurrentPinCode: string;
    coApplicantCountry: string;
    coApplicantState: string;
    coApplicantCity: string;
    coApplicantOccupation: string;
}

export class CredilaBeneRequest {
    iban: string;
    orderId: string;
    credilaQuoteOrderId: string;
    beneficiaryName: string;
    beneficiaryAddress: string;
    beneficiaryBankName: string;
    beneficiaryBankAddress: string;
    beneficiaryBankCountry: any;
    beneficiaryAccountNumber: string;
    iBan: string;
    internationalSwiftCode: string;
    bsbCode: string;
    transitNumber: string;
    sortCode: string;
    routingNo: string;
    intermediaryBankName: string;
    abaRouteNoOfIntermediaryBank: string;
    intermediaryBankAddress: string;
    intermediaryBankBIC: string;
    intermediaryBankSwiftCode: string;
    beneType: string;
    beneficiaryStreetNo: string;
    beneficiaryStreetName: string;
    beneficiaryTown: string;
    beneficiaryState: string;
    beneficiaryCity: string;
    beneficiaryCountry: string;
    additionalInformation: string;
    paidBy: string;
    isRemitterStudent: boolean;
    comment: string;
    universityName: any;
}

export class CredilaTravelRequest {
    orderId: string;
    credilaQuoteOrderId: string;
    departureDate: any;
    arrivalDate: any;
    issuerCode: string;
    paidBy: string;
    isRemitterStudent: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/order/OrderRequestModel.ts